import { Component, NgZone, ViewChild, ElementRef } from '@angular/core';

import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';
import { EinsatzplanData } from '../../providers/einsatzplan-data';

import moment from 'moment';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { AlertController } from 'ionic-angular';

import { Geolocation } from '@ionic-native/geolocation';
import { Platform } from 'ionic-angular';
import { EinsatzplanListPage } from '../einsatzplan/einsatzplan-list';

import 'rxjs/add/operator/map';
declare var google; // Added

@Component({
  selector: 'einsatzplan-detail',
  templateUrl: 'einsatzplan-detail.html'
})
export class EinsatzplanDetailPage {
  @ViewChild('map') mapElement: ElementRef; // Added

  sNormalColor = "primary";
  sCheckedColor = "secondary";
  viewmode:string;
  oSelectedEinsatzplan;
  map: any; // Added
  waypoints:any[];
  
  mapstyle :string;
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , private alertCtrl: AlertController
            , private einsatzplanData: EinsatzplanData
            , private platform: Platform
            , private geolocation:Geolocation
            ) {
    //let selectedpp = navParams.get('pp');
    

    //this.ueModel.iGrundid = navParams.data.grundid;
    this.oSelectedEinsatzplan = navParams.data;
    this.viewmode = "list";
    this.mapstyle = "hidden";
    this.waypoints = [];
    //console.log(this.oSelectedEinsatzplan);

   }

   switchViewMode(event){
     if(this.viewmode == "map"){
      //this.loadMap();  
      this.mapstyle = "visible";     
     }
     else{
      this.mapstyle = "hidden";            
     }
   }
    loadMap() {
    this.platform.ready().then(() => {
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        let actpos = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        let mapcenter = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        let waypointsgoogle = [];
        for(let m=0; m<this.oSelectedEinsatzplan.mandate.length; m++){
          for(let i=0; i<this.oSelectedEinsatzplan.mandate[m].pp.length; i++){
            if(i==0){
              mapcenter = new google.maps.LatLng(this.oSelectedEinsatzplan.mandate[m].pp[i].latit, this.oSelectedEinsatzplan.mandate[m].pp[i].longit);
            }
            this.waypoints.push({latit:this.oSelectedEinsatzplan.mandate[m].pp[i].latit, longit:this.oSelectedEinsatzplan.mandate[m].pp[i].longit, kurzname:this.oSelectedEinsatzplan.mandate[m].pp[i].kurzname, fkstatus:this.oSelectedEinsatzplan.mandate[m].pp[i].fkstatus, status:this.oSelectedEinsatzplan.mandate[m].pp[i].status, mandat: this.oSelectedEinsatzplan.mandate[m].mandat});
            let wp = {location: new google.maps.LatLng(this.oSelectedEinsatzplan.mandate[m].pp[i].latit, this.oSelectedEinsatzplan.mandate[m].pp[i].longit), stopover:true};
            waypointsgoogle.push(wp);
            //this.addMarker(this.oSelectedEinsatzplan.mandate[m].pp[i].latit, this.oSelectedEinsatzplan.mandate[m].pp[i].longit);
          }//for
        }//for
        let mapOptions = {
          center: mapcenter,
          zoom: 14,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        for(let i=0; i<this.waypoints.length; i++){
          //this.addMarker(this.waypoints[i].latit, this.waypoints[i].longit, this.waypoints[i].kurzname);
        }

        var directionsService = new google.maps.DirectionsService;
        var directionsDisplay = new google.maps.DirectionsRenderer;
        directionsDisplay.setMap(this.map);
        directionsService.route({
          origin: actpos,
          destination: actpos,
          optimizeWaypoints: true,
          waypoints: waypointsgoogle,          
          travelMode: 'DRIVING'
        }, function(response, status) {
          if (status === 'OK') {
            //console.log("response2");
            console.log(response);
            //console.log(response.routes[0].waypoint_order);
            /*
            let wp = this.waypoints;
            if(this.waypoints != null){
              this.waypoints.length=0;
              for(let i=0; i<response.routes[0].waypoint_order.length; i++){
                //console.log(wp[response.routes.waypoint_order[i]]);
                this.waypoints.push(wp[response.routes[0].waypoint_order[i]]);
              }

            }
            */
            //directionsDisplay.setDirections(response);
            directionsDisplay.setDirections(response);
          } else {
            console.log("directions failed");
          }
        });        
      }, (err) => {
        console.log(err);
      });    
    });    

      
    }
    ionViewDidEnter(){
      this.loadMap();   
    }

  addMarker(latit, longit, kurzname, mandat) { // To Add Marker
    
    let latLng = new google.maps.LatLng(latit, longit);

    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng
    });
 
    
    let content = "<h3>"+kurzname+"</h3><h4>"+mandat+"</h4>";
    this.addInfoWindow(marker, content);
  }
 
  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }    
   confirmStorno(kont){
     let title = "";
     let param: any;
     //-- Wenn kont == null, alle pp über alle mandate stornieren -----
      if(kont == null){
        kont = [];
        this.oSelectedEinsatzplan.mandate.forEach((mandat,index) => {
          kont = kont.concat(mandat.pp);
        });
      }
      
      if(Array.isArray(kont)){
        title = "Soll die Kontrolle wirklich storniert werden?";
        param = kont;
        
      }
      else{
        title = "Soll die Kontrolle des Parkplatzes '"+kont.kurzname+"' wirklich storniert werden?";
        param = {pp1 : kont};
      }
     
      let alert = this.alertCtrl.create();
      alert.setTitle(title);
      alert.setSubTitle('Grund:');
      alert.addInput({
          type: 'textarea',
          label: 'Grund',
      });

      alert.addButton('Abbrechen');
      alert.addButton({
        text: 'Ja',
        handler: (data: any) => {
          this.stornoEinsatzplan(param, data[0]);
            //this.testCheckboxOpen = false;
        }
      });

      alert.present();
      
   }

   stornoEinsatzplan(kont,reason){
       
        Promise.all([
            this.einsatzplanData.sotrno(kont, reason),            
          ]).then(data => {
            //console.log(data);
            //this.einsatzplan = this.einsatzplanData.data;      
            this.navCtrl.pop();
          });   
   }

   edit(){
    //oSelectedEinsatzplan.datum
    
    this.navCtrl.push(EinsatzplanListPage, {datum: this.oSelectedEinsatzplan.datum, zeit: this.oSelectedEinsatzplan.sollzeit});  
   }
  
}



// WEBPACK FOOTER //
// ./src/pages/einsatzplan/einsatzplan-detail.ts